import { Produto, ProdutoDesconto } from './produto';
import { TagGi } from './tag-gi';
import { Voucher } from './voucher';
import { VendaResposta } from './venda-resposta';
import { VendaSeguro } from './venda-seguro';
import { VendaFormaPag } from './venda-forma-pag';
import { PedidoCampoPersonalizadoSelecionado } from './pedido-campo-personalizado-selecionado';
import { ClienteCampoPersonalizado } from './cliente-campo-personalizado';
import { PedidoCampoPersonalizado } from './pedido-campo-personalizado';
import { TipoCIF } from './enum';
import { VendaItemImposto } from './venda-item-imposto';

export class Pedido {
  idVenda: number;
  idCupom: string;
  idMotivoPerda?: number;
  idEtapa?: number;
  // potTotal: string;
  nCupom: string;
  nPdv: number;
  nLoja: number;
  vendedor: number;
  nomeVendedor: string;
  cliente: number;
  valorTotal: number;
  nItens: number;
  da: number;
  valorDa: number;
  troco: number;
  nOrcamento: string;
  data: Date;
  hora: string;
  nCartao: string;
  nParcelas: number;
  gTotal: number;
  indicacao: number;
  status: number;
  flag: number;
  logMovi: Date;
  percentual: number;
  funcDesco: number;
  bc: number;
  ext: number;
  nECF: string;
  turno: number;
  nTurno: number;
  funcCanc: number;
  comprador: string;
  obs: string;
  franquia: number;
  obs2: string;
  obs3: string;
  frete: number;

  ordemEtapa: number;
  textoEtapa: string;

  //valorParcial: string;
  //desconto: string;
  valorFinal: number;

  vendaDireta: boolean;
  clienteFaturamento: number;

  cupomDesconto: number;
  cupomUsuario: number;
  cupomDataHora: Date;
  cupomUsuarioNome: string;
  usuario: string;

  tipoFrete: number;
  transportadora: number;

  financiamento: boolean;

  valorServico: number;
  valorServicoLiquido: number;
  painel: number;
  painelProduto: Produto;
  tensao: number;
  fase: number;
  tipoLocalizacao: number;
  txLocalizacao: number;
  entrega?: number;
  taxaDA: number;
  origemGI: number;
  tags: TagGi[];

  idFornecedor: number;
  descricaoFornecedor: string;

  orcamento: boolean;

  voucher?: number;
  valorVoucher: number;
  dadosVoucher: Voucher;

  idDescarga: number;

  dispEstoque: boolean;
  dataDispEstoque?: Date;

  freteManual: boolean;

  respostas: VendaResposta[];

  servicoEntrega: boolean;
  valorServicoEntrega: number;
  valorSeguro: number;
  seguros: VendaSeguro[];
  servicoEntregaManual: boolean;

  valorProjeto: number;
  valorProjetoLiquido: number;

  descontoIndividual: boolean;

  valorTotalItensComDesconto: number;
  formasPagamento: VendaFormaPag[];

  possuiNotaGenerica: boolean;
  vFutura: string;
  nNota: string;

  tipoCupomDesconto: number;
  cupomDescontoValor: number;

  tipoIntegracao: number;

  expirado: boolean;
  anotacaoStatus: string;

  camposPersonalizados: PedidoCampoPersonalizadoSelecionado[];
  camposPersonalizadosMontar: PedidoCampoPersonalizado[];

  valorTotalCalculado: number;
  valorTotalFixo: number;

  ibgeInstalacao: string;
  ufInstalacao: string;

  reserva: number;
  aliqImpRef: number;

  substituicao: boolean;

  tipoCIF: number;

  idFrete: number;
  percentualFrete?: number;

  fornecedorSugerigo: number;
  cidadeCD: number;
  fornecedorSugerido: number;

  ipi: number;
  ibs: number;
  cbs: number;

  foraDaRegra: boolean;
  multiFormaPagamento: boolean;

  impostos: VendaItemImposto[];
  valorImpostos: number;
  impostosPendente: boolean;

  idLoja: number;
  possuiFinSimulacao: boolean;
}

export class ItemPedido {
  idCupom: string;
  nItem: number;
  produto: number;
  cc: number;
  qt: number;
  pUnitario: number;
  pUnitarioSugerido: number;
  vTotal: number;
  vTotalSugerido: number;
  da: number;
  valorDa: number;
  comissao: number;
  log: Date;
  percentual: number;
  pCusto: number;
  produtoTela: Produto;

  qtAnterior: number;
  checado: boolean;

  qtSugerida: number;

  vPCusto?: number;
  vCustoTotal?: number;

  situacaoProduto: string;
  frete: number;
  imagem$: Promise<any>;
  buscouImagem: boolean;
  obs: string;
  // origemGI: number;

  alterado: boolean;

  qtEstoqueMinimo: number;

  det1: string;

  itemDesc: ItemDesc;

  precoCif: number;

  valorDA: number;

  dataDisponibilidade: Date;
  pVendaOriginal: number;

  aliqIpi: number;
  ipi: number;
  ibs: number;
  cbs: number;
}

export class ItemDesc {
  preco: number;
  descontos: ProdutoDesconto[];
}
